export default "__VITE_ASSET__qDibcSu$__"